import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import { FormSubTitleDespHybrid, FormTitleHybrid, FormUpload, HybridFormLabelGrey, UploadFormComboBox } from '../validation/Form-Components';
import udata from '../hybriddata/uploaddata.json';
import { useEffect, useState } from 'react';
import certIcon from '../hybridImages/certificate.png';
import bankIcon from '../hybridImages/bank.png';
import docTypeList from '../hybriddata/docstypes.json';
import { reqDDLValidator } from '../validation/Validators';
import CusAddBtn from '../components/CusAddBtn';
import StatusYellowBarBtn from '../hybridcomponents/StatusYellowBarBtn';
import greenTickIcon from '../hybridImages/chck_green.png';
import { DropDownButton } from '@progress/kendo-react-buttons';
import dotIcon from '../hybridImages/Circle.png';
import { ComboBox } from '@progress/kendo-react-dropdowns';
import CusToast from '../components/CusToast';
import config from '../appconfig/config.json';
import storage from '../factory/StorageFactory';
import service from '../services/ApiService';
import Loading from '../components/Loading';
import { useHistory } from 'react-router-dom';
import helper from '../factory/Helper';
import eService from '../services/StatusEnquiryApiService';
import ImageViewPopup from '../hybridcomponents/ImageViewPopup';
import axios from "axios";
import { isMobile } from 'react-device-detect';

const UploadDetails = (props) => {
    const history = useHistory();
    let timer; 
    const ACT_REMOVE = 'REMOVE',  ACT_REPLACE = 'REPLACE';
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [docsTypeErr,setDocsTypeErr] = useState({index:0,isError:false})

    const [attachmentList, setAttachmentList] = useState([{ddlDocsType:{},supptDocs:[]}])

    const [disableUploadFile, setDisableUploadFile] = useState(true);//def disable 
    const [disableBtnUpload,setDisableBtnUpload] = useState(false);

    const [statusEnqResponse,setStatusEnqResponse] = useState();
    const [uploadedFiles, setUploadedFiles] = useState([]);
 
    //upload 
    const [files, setFiles] = useState([]);
    const [events, setEvents] = useState([]);
    
    const [isLoading,setIsLoading] = useState(true);
    const [isSaving,setIsSaving] = useState(false);

    const [showImgPopup, setShowImgPopup] = useState(false);
    const [displayImg, setDisplayImg] = useState("");
    const [displayFileName, setDisplayFileName] = useState("Upload File");

    const btnItems = [
        "Replace File",
        "Remove File"
    ]

    useEffect(() => {
        console.log('@UploadDetails useEffect');
        
        if(helper.isTokenExpired()) {
            props.history.push(config.route.SessionExpired);
            return;
        }
  
        window.scrollTo(0, 0);
      
        getStatusEnquiry();
        return () => {
            console.log('clean up..')
            clearTimeout(timer);
        }
    }, []);

    const getStatusEnquiry = () => {

        const sid = storage.getStateId();
        const rno = storage.getRefNo();
        eService.getStatusEnquiry(sid,rno).then( res => {
            
            let resData = res.data.model.fields.request;
            setStatusEnqResponse(resData);
            getDocuments();
        })
        .catch( err => {
         
            console.log('getStatus err: ',err);
            props.history.push(config.route.InvalidEntity,{errType:config.ErrType.GetStatusFailed});
        })
    }
    const getDocuments = () => {
        const paramRefNo = storage.getRefNo();
        service.getAllDocument(paramRefNo).then(res => {
            // console.log('res=> ',res);
            const resData = res.data.model;
            if(resData.length > 0) {
                setUploadedFiles(resData)
                bindAttchmentList(resData);
            }
            setIsLoading(false);
            setIsSaving(false);
        })
        .catch(err => {
            console.log('err=>', err);
            setIsLoading(false);
            setIsSaving(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const bindAttchmentList= (data) => {
        let tempArray = [];
        for(let i = 0; i < data.length; i++) {
            const resObj = data[i];
  
            tempArray.push(formatAttachmentObj(resObj));
        }

        setAttachmentList(tempArray);
    }

    const formatAttachmentObj = (resObj) => {

        const ddlDocsTypeObj = helper.getObjInArrayByLabel(resObj.fileDescription,docTypeList);
    
        const supptDocsObj = {
            extension:resObj.fileExtension,
            name:resObj.rawFileName,
            progress:0,
            size:resObj.fileSizeInBytes,
            status:2,
            uid:resObj.fileID,
            owner:resObj.owner,
            description: resObj.fileDescription
        }

        const formatObj = {
            ddlDocsType:ddlDocsTypeObj,
            supptDocs:[supptDocsObj]
        }
 
        return formatObj;
    }

    const handleSave = () => {
        console.log('handleSave');
        goNext();
    }

    const handleDone = () => {
        console.log('handleDone');

        if(!validateEachAttachment(attachmentList)) {
            showErrMsg(udata.error.nodocs);
            return;
        }

        setIsSaving(true);

 
        if(attachmentList.length > 0) {
        
            const rno = storage.getRefNo();
            service.getAllDocument(rno).then(res => {
                // console.log('res=> ',res);
                const resData = res.data.model;
                const uploadedDocsArray = resData;  // get uploaded Files

                let array1 = []; 
                let tempArray = attachmentList;
                const lRow = attachmentList.length -1; //last row index
         
                if(isEmptyObj(attachmentList[lRow].ddlDocsType)){
                   for(let i = 0 ; i < lRow; i++) {
                     array1.push(attachmentList[i]);
                   }
                }
                else {
                    array1 = tempArray;
                }

                setUploadedFiles(uploadedDocsArray);// files already uploaded before

                const uniqueTo1 = array1.filter(obj1 =>  
                    !uploadedDocsArray.some(obj2 => obj1.supptDocs[0].uid === obj2.fileID)
                );
      
                if(uniqueTo1.length > 0) {
            
                    for(let i=0; i < uniqueTo1.length; i++) {

                        if((uniqueTo1[i].supptDocs.length > 0) && (!isEmptyObj(uniqueTo1[i].ddlDocsType))) {
                              //Upload file
                              const file = uniqueTo1[i].supptDocs[0];
                              const docsType= uniqueTo1[i].ddlDocsType.label;
                              uploadFileToServer(file, docsType, i, uniqueTo1.length);
                        }
                        else {
                          //no upload that file
                        }
                    }
                    //out of loop then will stop
                    // console.log('out of loop')
                }
                else {
                    setIsSaving(false);
                    // console.log('no unique value to upload');
                    goNext();
                }
            })
            .catch(err => {
                console.log('err=>', err);
                setIsSaving(false);
                showErrMsg(config.error.GetApiFailed);
            })
       
        }
        else {
            setIsLoading(false);
        }
    }

    const handleDDLDocsType = (e,i) => {
        // console.log('handleDDLDocsType',e.value);
        if(e.value === null) {
            setDisableUploadFile(true);
        }
        else {
            setDisableUploadFile(false);
        }

        const list = [...attachmentList];
        
        list[i].ddlDocsType = e.value;
        list[i].supptDocs = list[i].supptDocs;
        // console.log('DocsType updated list ',list);
        
        if(e.value !== null) {
            if(validateNumOfDocsByType(list,i)) {
                setAttachmentList(list);
            }
            else {
                setDisableUploadFile(true);
                showErrMsg(udata.error.maxDocsType);
            }
        } 
    }

    const validateNumOfDocsByType = (arrayList,index) => {

        let isValid = true;
        if(arrayList.length > 0) {
            const docsTypeFS = docTypeList[0].value;  //Financial Report
            const docsTypeMA = docTypeList[1].value;  //Management Account
            const docsTypeDA = docTypeList[2].value;  //Draft Account
            const docsTypeBS = docTypeList[3].value;  //Bank Statement
            const docsTypeOTP = docTypeList[4].value; //Option to Purchase (Property Loans)
    
            const filteredFSArray = arrayList.filter( item => item.ddlDocsType.value === docsTypeFS);
            const numberOfObjFS = filteredFSArray.length;
    
    
            const filteredMAArray = arrayList.filter( item => item.ddlDocsType.value === docsTypeMA);
            const numberOfObjMA = filteredMAArray.length;
 
    
            const filteredDAArray = arrayList.filter( item => item.ddlDocsType.value === docsTypeDA);
            const numberOfObjDA = filteredDAArray.length;
    
    
            const filteredBSArray = arrayList.filter( item => item.ddlDocsType.value === docsTypeBS);
            const numberOfObjBS = filteredBSArray.length;
     
    
            const filteredOTPArray = arrayList.filter( item => item.ddlDocsType.value === docsTypeOTP);
            const numberOfObjOTP = filteredOTPArray.length;
 
    
            if(numberOfObjFS > 10 || numberOfObjMA > 10 || numberOfObjDA > 10 
                ||numberOfObjBS > 10 || numberOfObjOTP > 10) {
                    isValid = false;
                    setDocsTypeErr({index:index,isError:true})
                }
                else {
                    isValid = true;
                    setDocsTypeErr({index:index,isError:false})
                }
        }

        return isValid;
    }

    const onAdd = async (event,i) => {
   
        // console.log("onAdd ",event.newState);
        // console.log('affected file: ',event.affectedFiles[0])
        const uploadedFile = event.affectedFiles[0];
        if(uploadedFile.validationErrors) {
            const fileErrType = uploadedFile.validationErrors[0];
            if(fileErrType === udata.error.invalidFileExt) {
              showErrMsg(udata.error.uploadExt);
            }
            else if(fileErrType === udata.error.invalidFileMaxSize) {
              showErrMsg(udata.error.fileSize10MB);
            }
            else {
              showErrMsg(udata.error.fileSize10MB);
            }
            return;
        }

        //validation success
 
          const tempfiles = event.newState;
          setFiles(event.newState);
          const list = [...attachmentList];
          list[i].ddlDocsType = list[i].ddlDocsType;
          list[i].supptDocs = tempfiles;
          const k = list.length - 1;
          const docsTypeValue =list[k].ddlDocsType.label;
      };
    
      const onRemove = (event, index) => {
 
        setFiles(event.newState);
        // deleteFile(event.affectedFiles[0]);
      };

      const validateEachAttachment = (arrayList) => {
        // console.log('validateEachAttachment: ',arrayList.length);
        let isValid = true;
 
        if(arrayList.length > 0) {
            for(let i = 0; i < arrayList.length; i++) {
                // console.log('ivalue: ', i)
                const lastRow =attachmentList.length-1;  //last row
                const kValue = attachmentList[i];
                if(i !== lastRow) {
                 
                    if(isEmptyObj(kValue.ddlDocsType) || (kValue.supptDocs.length === 0)){
                        isValid = false;
                        return isValid;
                    }
                }
                else { // i is last row 
                    if((isEmptyObj(kValue.ddlDocsType) === false) && (kValue.supptDocs.length === 0)) {
                        isValid = false;
                        return isValid;
                    }
                }
            }
        }
        else {
            isValid = false;
        }
 
        return isValid;
      }

      const isEmptyObj = (obj)=> {
        if(obj === null) return true;
        return Object.keys(obj).length === 0;
      }

 
    const uploadFileToServer = (file,docsType, iValue, arrayLength) => {
 
        const rawFile = file.getRawFile();
        const rno = storage.getRefNo();
        const fName = file.name;
        const fDocsType = docsType;
        const fId= file.uid;
        const apIDNum = statusEnqResponse.ApplicantIDNum;
 
        service.uploadDocument(rawFile,rno,fName,fDocsType,fId,apIDNum).then(res => {
            let resData = res.data;

            if(resData.message !== null) {
                setIsSaving(false);
                showErrMsg(config.error.SaveApiFailed);
                return;
            }
            
            if(iValue === arrayLength - 1) {
                setIsSaving(false);
                goNext();
                return;
            }
        }).catch(err => {
            console.log('err: ',err);
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        })
    }

    const deleteUploadedFile = (file,docsType,action,i) => {

        let idExist = false;

        const params = {
            fileID:file.uid,
            referenceNo:storage.getRefNo(),
            description:docsType
        }
        if(uploadedFiles.length > 0) {
            idExist = uploadedFiles.some(obj => obj.fileID === file.uid)  
          
            if(idExist) {
                setIsSaving(true);
                service.deleteDocument(params).then(res => {
                    setIsSaving(false);
                    let resData = res.data;
                    updateAttachmentList(action,i);
                }).catch(err => {
                    console.log('err: ',err);
                    setIsSaving(false);
                    showErrMsg(config.error.SaveApiFailed);
                })
            }
            else {
                updateAttachmentList(action,i);
            }
        }
        else {
            updateAttachmentList(action,i);
        }
    }

    const updateAttachmentList = (action,i) => {
        if(action === ACT_REPLACE) {
            const list = [...attachmentList];
            list[i].ddlDocsType = list[i].ddlDocsType;
            list[i].supptDocs = [];
            setAttachmentList(list);
            return;
        }

        if(action === ACT_REMOVE) {
            const list = [...attachmentList];
            list.splice(i,1);
            setAttachmentList(list);
            return;
        }
    }

    const viewDocument = (file,docsType) => {
        setIsSaving(true);
        const refNo = storage.getRefNo();
        const fDesc = docsType;
        const fId = file.uid;
        const fExt = file.extension;
        const fName = file.name;
 
        if (fExt.toLowerCase() === ".pdf") {
          //pdf file
          downloadPdf(refNo, fDesc, fId, fName);
        } else {
          //image file
          service.getDocument(refNo, fDesc, fId)
            .then((res) => {
              setIsSaving(false);
              const resData = res.data.model;
              if (resData.content !== "") {
                const imgStr = "data:image/jpg;base64," + resData.content;
    
                setDisplayImg(imgStr);
                setDisplayFileName(fName);
                setShowImgPopup(true);
              } else {
                showErrMsg(config.error.GetApiFailed);
                setShowImgPopup(false);
              }
            })
            .catch((err) => {
              setIsSaving(false);
              console.log("err: ", err);
              showErrMsg(config.error.GetApiFailed);
              return;
            });
        }
      };
    
 
        const downloadPdf = (refNo, fDesc, fId, fName) => {
            const pdfUrl = service.getPdfFileUrl(refNo, fDesc, fId);
            // window.open(pdfUrl);
            axios({
              url: pdfUrl, //your url
              method: "GET",
              responseType: "blob", // important
              headers: {
                "Content-Type": "application/octet-stream",
                Authorization: "Maybank" + " " + storage.getToken(),
              },
            }).then((response) => {
              setIsSaving(false);
              const resData = response.data;
              const url = window.URL.createObjectURL(new Blob([resData]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fName); //or any other extension
              document.body.appendChild(link);
              link.click();
            });
          };

    const goNext = () => {
        const UEN = statusEnqResponse.StatusDtls.UEN;
        const IDNum = statusEnqResponse.ApplicantIDNum;
        const SID = storage.getStateId();
        const RefNum =storage.getRefNo();
        history.push(config.route.StatusDetails,{from: config.route.UploadDetails,uen:UEN,idNum:IDNum,sid:SID,refNo:RefNum});
    }

    const checkUploadNowBtnDisable = () => {
        let result = true;
        if(attachmentList.length > 0) {
            for(let i=0; i < attachmentList.length; i++){
    
                if(attachmentList[i].supptDocs.length === 0 || isEmptyObj(attachmentList[i].ddlDocsType)) {
                  
                    result = true;
                }
                else {
                 
                    result = false;
                }
            }
        }
 
        setDisableBtnUpload(result);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    
    if(isLoading) {
        return(
          <Loading />
        )
    }
    
    return(
        <div className="container-fluid">
            <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>{udata.mainTitle}</h2>
                    </div>
                </div>
            </div> <br/>
            <FormContainer>
            <Form
                // onSubmit={handleSubmit}
                // initialValues={initFormData}
                // key={JSON.stringify(initFormData)}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                            <Field component={FormTitleHybrid} id={'ft1'} name={udata.formTitle.ft1}/> 
 
                            <Field component={HybridFormLabelGrey} labelId={'lblGraySubft1'} labelName={udata.formTitle.ftSub1} />
                        </fieldset>
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className='yellowUploadInfoTxtbox'>
                                    <Field component={FormSubTitleDespHybrid} id={'ftSubDesc1'} name={udata.label.uploadInfo} />
                                    <FieldWrapper>
                                        <div className='m-wdt-95'>
                                            <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <div style={{display:'-webkit-inline-box'}}>
                                                    <img className='upload-left-icon-size' src={certIcon} alt='cert' />&nbsp;&nbsp;&nbsp;
                                                    <li className='upload-li-txt-font'>{udata.label.financeReport}</li>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <div style={{display:'-webkit-inline-box'}}>
                                                    <img className='upload-left-icon-size' src={bankIcon} alt='bankIcon' />&nbsp;&nbsp;&nbsp;
                                                    <li className='upload-li-txt-font'>{udata.label.bankStatement}</li>
                                                </div>
                                            </div>
                                            </div>
                                            <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <div style={{display:'-webkit-inline-box'}}>
                                                    <img className='upload-left-icon-size' src={certIcon} alt='bankIcon' />&nbsp;&nbsp;&nbsp;
                                                    <li className='upload-li-txt-font'>{udata.label.otp}</li>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </FieldWrapper>
                                </div>
                            </div>
                        </div>
              
                        <FieldWrapper>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <label className="box text-left" style={{color:'#464646', fontSize:'16px'}}>{udata.formSubTitle.subft1}</label>
                                </div>
                            </div>
                        </FieldWrapper>


                    {attachmentList.map((x,i) => {
                        return(
                            <div key={'upload'+i}>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                                    <div className="box">
                                        <ComboBox id={'ddlDocsType'+i} 
                                            name={'ddlDocsType'+i}
                                            data={docTypeList}
                                            placeholder={'Type of document'}
                                            textField={'label'}
                                            required={true}
                                            validator={reqDDLValidator}
                                            disabled={(x.supptDocs.length > 0)?true:false}
                                            value={(docsTypeErr.index === i && docsTypeErr.isError === true)?null:x.ddlDocsType}
                                            onChange={e => handleDDLDocsType(e,i)} />
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7 padTop1">
                                    <div className="box">
                                        {(x.supptDocs.length === 0)&&
                                        <Field
                                            key={"supptDocs"+i}
                                            id={"supptDocs"+i}
                                            name={"supptDocs"+i}
                                            optional={false}
                                            disabled={disableUploadFile}
                                            component={FormUpload}
                                            restrictions={{
                                                allowedExtensions: ["png", "jpg", "jpeg", "pdf"],
                                                maxFileSize: 15000000,
                                            }}
                                            files={x.supptDocs}
                                            onAdd={e => onAdd(e,i)}
                                            onRemove={e => onRemove(e,i)}
                                        />
                                        }
                                        {(x.supptDocs.length > 0)&&
                                        <div style={{width:'100%'}}>
                                           <div className='bblineG'>
                                                <span className='txt-upload'>
                                                {(x.supptDocs.length > 0)? 
                                                    x.supptDocs[0].name:''
                                                }
                                                </span>
                                                <img style={{float:'right',width:'20px'}} src={greenTickIcon} alt='icon' />
                                            </div>
                                            <div style={{width:'10%',float:'right'}}>
                                                {(x.supptDocs[0].owner && (x.supptDocs[0].owner !== statusEnqResponse.ApplicantIDNum))?
                                                <DropDownButton 
                                                    fillMode={"flat"}
                                                    imageUrl={dotIcon}
                                                    items={['View File']}
                                                    onItemClick={(e) => {
                                                        //view document
                                                        const docType = x.ddlDocsType.label;
                                                        viewDocument(x.supptDocs[0],docType);
                                                    }}
                                                /> 
                                                :
                                                <DropDownButton 
                                                    fillMode={"flat"}
                                                    imageUrl={dotIcon}
                                                    items={btnItems}
                                                    onItemClick={(e) => {
                                                        // console.log('onItemClick',e);
                                                        if(e.item === btnItems[0]) { //remove file only
                                                            //delete file api call 
                                                 
                                                            const file = x.supptDocs[0];
                                                            const docType = x.ddlDocsType.label;
                                                            setDisableUploadFile(false);
                                                            deleteUploadedFile(file,docType,ACT_REPLACE,i)
                                                     
                                                            // const list = [...attachmentList];
                                                            // list[i].ddlDocsType = list[i].ddlDocsType;
                                                            // list[i].supptDocs = [];
                                                            // setAttachmentList(list);
                                                            return;
                                                        }

                                                        if(e.item === btnItems[1]) { //DELETE
                                                            //delete the file first, remove from the list
                                                            const file = x.supptDocs[0];
                                                            const docType = x.ddlDocsType.label;
                                                            deleteUploadedFile(file,docType,ACT_REMOVE,i)
                                                            return;
                                                        }
                                                    }}
                                                /> 
                                                }
                                            </div>
                                        </div>
                                    }
                                    </div>
                                </div>
                            </div>
                            {(docsTypeErr.index === i && docsTypeErr.isError === true) &&
                            <div className="row around-xs inputPair elementVisible">
                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                    <span className='txt-error'>
                                    {udata.error.maxDocsType}
                                    </span>
                                </div>
                            </div>
                            }
                            </div>
                            
                        )
                    })}
                      
                        <CusAddBtn id={'addbtn1'} 
                            label={udata.label.addAttachment} 
                            disabled={false}
                            onClick={() => {
                                if(attachmentList.length > 0) {
                                    const k =attachmentList.length-1;
                                    const kValue = attachmentList[k];
                                    if(isEmptyObj(kValue.ddlDocsType) || kValue.supptDocs.length === 0) {
                                        showErrMsg(udata.error.nodocs);
                                        return;
                                    }
                                }
                                setAttachmentList([...attachmentList, {ddlDocsType:{},supptDocs:[]}])
                            }}
                        />
                                                
                        <FieldWrapper>
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div className='upload-note smallFontSize'>   
                                        {udata.label.note}  
                                        <ul className='dotlist'>
                                            <li>{udata.label.notetxt1}</li>
                                            <li>{udata.label.notetxt2}</li>
                                        </ul> 
                                    </div>
                                </div>             
                            </div>
                        </FieldWrapper>
                        <br/>
                    </FormElement>
                )}/>
              
            </FormContainer>
            <br/><br/><br/>
            {isMobile && <><br/><br/><br/><br/></>}
            <StatusYellowBarBtn 
                label={udata.label.submittedTxt} 
                btnName1={udata.label.btnSave} 
                btnName2={udata.label.btnUpload}
                btn1Disabled={false} 
                btn2Disabled={disableBtnUpload}
                onClickSave={handleSave}
                onClickDone={handleDone} 
            />
            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer}  /> 
            {isSaving&& <Loading />}
            <ImageViewPopup
                popupTitle={displayFileName}
                data={displayImg}
                showImgView={showImgPopup}
                setShowImgView={setShowImgPopup}  />
     
        </div>
    )
}

export default UploadDetails;